import './Contact.css';
import ContactContent from './ContactContent';
import SideMenu from '../SideMenu';

function Contact() {
  return (
    <div className = 'contact'>
      <SideMenu />
      <div className = 'contact-content'>
        <ContactContent />
      </div>   
    </div>
  );
}

export default Contact;